module.exports = __webpack_public_path__ + "static/img/Dream-06.ad68ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Dream House/Dream-06.jpg
// module id = FYSB
// module chunks = 7